<div class="min-h-screen flex flex-col items-center bg-gray-100 px-4 py-10">

  <!-- Logo -->
  <div class="mb-8">
    <img src="/assets/images/Logo-Matwins.png" alt="Logo Matwins" class="w-48 h-32 object-contain">
  </div>

  <!-- Card -->
  <div class="w-full max-w-md rounded-2xl shadow-xl overflow-hidden">
    <!-- Header gradient -->
    <div class="bg-gradient-to-r from-purple-600 to-blue-500 px-6 py-5">
      <h1 class="text-white text-2xl font-bold text-center">Point Of Services</h1>
      <p class="text-purple-200 text-xs text-center mt-1 uppercase tracking-widest">
        Select your Point of Services
      </p>
    </div>

    <!-- Body -->
    <div class="bg-gradient-to-b from-purple-700 to-indigo-800 px-6 py-6 space-y-4">

      <!-- Select -->
      <select
        [(ngModel)]="selectedPosId"
        class="w-full px-4 py-3 rounded-lg border border-gray-300 bg-white text-gray-700 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
        <option [ngValue]="null" disabled selected></option>
        @for (pos of posList(); track pos) {
          <option [ngValue]="pos.id">
            {{ pos.name }}
          </option>
        }
      </select>

      <!-- Submit -->
      <button
        (click)="onSubmit()"
        [disabled]="selectedPosId == null"
        class="w-full py-3 rounded-lg text-white font-semibold text-sm transition-colors"
        [class]="selectedPosId != null ? 'bg-teal-500 hover:bg-teal-600 cursor-pointer' : 'bg-teal-300 cursor-not-allowed'">
        Submit
      </button>

      <!-- Cancel -->
      <button
        (click)="onCancel()"
        class="w-full py-3 rounded-lg bg-gray-400 hover:bg-gray-500 text-white font-semibold text-sm cursor-pointer transition-colors">
        Cancel
      </button>
    </div>
  </div>
</div>